import angular from 'angular'

import { CashDiscountingModalController } from './cash-discounting-modal/cash-discounting-modal.controller'
import { PartialAuthModalController } from './partial-auth-modal/partial-auth-modal.controller'
import { PartialPaymentModalController } from './partial-payment-modal/partial-payment-modal.controller'
import { PaymentModalService } from './payment-modal.service'
import { PaymentsResourceService } from './payments-resource.service'
import { CashModalController } from './cash-payment-modal/cash-payment-modal.controller'
import { LSPAYModalController } from './lspay-payment-modal/lspay-payment-modal.controller'
import { LSPayEcomRefundModalController } from './lspay-ecom-refund-modal/lspay-ecom-refund-modal.controller'
import { PayLinkLimitModalController } from './pay-link-limit-modal/pay-link-limit-modal.controller'
import { LSPayRecoveryModalController } from './lspay-recovery-modal/lspay-recovery-modal.controller'

// React Components
import { CashPaymentModalComponent } from './cash-payment-modal/CashPaymentModal'
import { BackToSaleHeaderComponent } from './back-to-sale-header/BackToSaleHeader'
import { LSPAYPaymentModalComponent } from './lspay-payment-modal/components/LSPAYPaymentModal'
import { CashDiscountModalComponent } from './cash-discounting-modal/CashDiscountingModal'
import { PartialPaymentModalComponent } from './partial-payment-modal/PartialPaymentModal'
import { PartialAuthModalComponent } from './partial-auth-modal/PartialAuthModal'
import { IntegratePaymentModalComponent } from './integrated-payment/integrated-payment-modal/IntegratedPaymentModal'
import { IntegratedPaymentModalController } from './integrated-payment/integrated-payment-modal/integrated-payment-modal.controller'
import { SwiperPaymentModalComponent } from './swiper-payment-modal/react/SwiperPaymentModal'
import { LSPayEcomRefundModalComponent } from './lspay-ecom-refund-modal/LSPayEcomRefundModal'
import { PayLinkLimitModalComponent } from './pay-link-limit-modal/PayLinkLimitModal'
import { LSPayRecoveryModalComponent } from './lspay-recovery-modal/LSPayRecoveryModal'

angular
  .module('webregister.modals')
  .service('paymentModalService', PaymentModalService)

angular
  .module('webregister.services')
  .service('paymentsResourceService', PaymentsResourceService)

angular
  .module('webregister.controllers')
  .controller('partialPaymentModalController', PartialPaymentModalController)
  .controller('lspayPaymentModalController', LSPAYModalController)
  .controller('cashModalController', CashModalController)
  .controller('cashDiscountingModalController', CashDiscountingModalController)
  .controller('partialAuthModalController', PartialAuthModalController)
  .controller(
    'integratedPaymentModalController',
    IntegratedPaymentModalController
  )
  .controller('lspayEcomRefundModalController', LSPayEcomRefundModalController)
  .controller('payLinkLimitModalController', PayLinkLimitModalController)
  .controller('lspayRecoveryModalController', LSPayRecoveryModalController)

angular
  .module('webregister.components')
  .component('cashPaymentModal', CashPaymentModalComponent)
  .component('backToSaleHeader', BackToSaleHeaderComponent)
  .component('lspayPaymentModal', LSPAYPaymentModalComponent)
  .component('cashDiscountingModal', CashDiscountModalComponent)
  .component('partialPaymentModal', PartialPaymentModalComponent)
  .component('partialAuthModal', PartialAuthModalComponent)
  .component('integratedPaymentModal', IntegratePaymentModalComponent)
  .component('swiperPaymentModal', SwiperPaymentModalComponent)
  .component('lspayEcomRefundModal', LSPayEcomRefundModalComponent)
  .component('payLinkLimitModal', PayLinkLimitModalComponent)
  .component('lspayRecoveryModal', LSPayRecoveryModalComponent)
